import CommunicationDetailsEntity from './CommunicationDetailsEntity';
export const mapCommunicationsToEntities = (communications = []) => communications.map(mapCommunicationToEntity);
export const mapCommunicationToEntity = (communicationDetails) => new CommunicationDetailsEntity(communicationDetails);
export const isCommunicationDetailsEntity = (item) => item instanceof CommunicationDetailsEntity;
